import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const GoogleAnalytics = () => {
  const [gaId, setGaId] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await axios.get(`${API}/settings`);
        if (res.data.google_analytics_id) {
          setGaId(res.data.google_analytics_id);
        }
      } catch (e) {
        console.error("Failed to fetch settings for GA:", e);
      }
    };
    fetchSettings();
  }, []);

  useEffect(() => {
    if (!gaId) return;

    // Add gtag.js script
    const script = document.createElement("script");
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    script.async = true;
    document.head.appendChild(script);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", gaId);

    return () => {
      // Cleanup
      document.head.removeChild(script);
    };
  }, [gaId]);

  return null;
};

export default GoogleAnalytics;
